import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import PatientPortalShell from '@/modules/referral/components/PatientPortalShell';
import { patientPortalApi } from '../api/patientPortal.api';
import FamilyTreeDiagram from '../components/FamilyTreeDiagram';
import { SERIF } from '@/pages/landing/iithBrand';

export default function PatientFamilyPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    patientPortalApi.family()
      .then(setData)
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, []);

  const members = data?.members || [];
  const selfId = data?.self_id;
  const self = members.find((m) => m.id === selfId) || members[0];

  return (
    <PatientPortalShell>
      <h1 className="text-2xl font-bold text-[#071B34] mb-1" style={{ fontFamily: SERIF }}>Family tree</h1>
      <p className="text-sm text-[#5A6B7C] mb-6">
        You at the top — dependents branch below. Tap a person for their care history.
      </p>
      {loading ? (
        <div className="py-16 text-center"><Loader2 className="h-7 w-7 animate-spin mx-auto text-[#F15A22]" /></div>
      ) : !self ? (
        <p className="text-sm text-[#7A8B9C]">No linked patient profile yet.</p>
      ) : (
        <FamilyTreeDiagram self={self} members={members} />
      )}
    </PatientPortalShell>
  );
}
